module.exports = __webpack_public_path__ + "media/images/emblems/Pomy-coat_of_arms-1da3e235a2f258ed447f11771a207e85.svg";